import React from 'react';

import moment from 'moment';
import { observer } from 'mobx-react'

import ObjectsVirtualizedTable, {createDefaultCellRenderer2} from 'components/ObjectsVirtualizedTable';

import IconButton from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHorizOutlined from '@material-ui/icons/MoreHorizOutlined'


const TicketsInlineBlockMenu = ({ objectId, onDelete, onToggleSold }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        setAnchorEl(null);
        onDelete(objectId);
    }

    const handleToggleSold = () => {
        setAnchorEl(null);
        onToggleSold(objectId);
    }

    return (
        <div>
            <IconButton aria-label="delete" onClick={handleClick}>
                <MoreHorizOutlined fontSize="small" />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleDelete}>Delete</MenuItem>
                <MenuItem onClick={handleToggleSold}>Toggle Sold</MenuItem>
            </Menu>
        </div>
    );
}

const Sold = ({ticket})=> {
    console.log("rowd ", ticket)
    const label = ticket.isSold ? "yes": ""
    return <div>{label}</div>
}


const TicketsTableVirtualized = observer(({ store, onSort, onSelectObject, className, ...rest }) => {

    const results = store.selectObjectsState.objects
    
    const getRowData = ({ index }) => {
        const obj = results[index]
        const ticketCode = obj.ticketCode
        const id = obj.id
        const created = moment(obj.created).format('DD/MM/YYYY HH:mm')
        const validUntil = moment(obj.validUntil).format('DD/MM/YYYY HH:mm')
        const usedAt = obj.usedAt ? moment(obj.usedAt).format('DD/MM/YYYY HH:mm') : ""
        const isSold = obj.isSold

        return { id, ticketCode, created, validUntil, usedAt, isSold, obj }
    }

    const sort = (column) => {
        if (onSort) {
            onSort(column)
        }
    }

   
    const onDelete = (objectId) => {
        if (window.confirm("Do you really want to delete your this ticket?")) {
            store.delete(objectId);
        }
    }

    const onToggleSold = (objectId) => {
        store.toggleSold(objectId);
    }

    const columns = [
        {
            width: 400,
            label: 'Ticket code',
            dataKey: 'ticketCode',
            rowClick: false,
        },
        {
            width: 400,
            label: 'Created',
            dataKey: 'created',
            rowClick: false,
            // sort: () => sort('name') 
        },
        {
            width: 200,
            label: 'Geldig tot',
            dataKey: 'validUntil',
            rowClick: false,
        },
        {
            width: 200,
            label: 'Is used at',
            dataKey: 'usedAt',
            rowClick: false,
        },
        {
            width: 200,
            label: 'Is sold',
            dataKey: 'isSold',
            rowClick: false,
            renderCell: ({ rowData, cellData }) => (<Sold ticket={rowData}
                    objectId={rowData.id}/>),
            
        },
        {
            width: '100%',
            label: 'Actions',
            dataKey: 'id',
            renderCell: ({ rowData, cellData }) => (<TicketsInlineBlockMenu
                    objectId={rowData.id}
                    onDelete={onDelete} 
                    onToggleSold={onToggleSold}/>),
            rowClick: false,
        },
    ]
 

    const onSelectRow = (rowData)=> {
        onSelectObject(rowData.obj.id);
    }

    const cellRenderer = createDefaultCellRenderer2({ columns});


    return  <ObjectsVirtualizedTable 
        store={store} 
        columns={columns} 
        getRowData={getRowData}
        cellRenderer={cellRenderer}
    />

    
});

export default TicketsTableVirtualized;